import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormRhombus: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-rhombus"><path d="M10.5003 1.79286C11.18 0.660149 12.8225 0.660238 13.5022 1.79286L19.0852 11.0995C19.4177 11.6537 19.4177 12.3461 19.0852 12.9003L13.5022 22.2069C12.8224 23.3395 11.1799 23.3396 10.5003 22.2069L4.91726 12.9003C4.58486 12.3462 4.58489 11.6536 4.91726 11.0995L10.5003 1.79286Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFormRhombus;
